import type { InputMappingGroup } from '@/features/InputMapping/types';
import UnorderedList from '@/components/modals/InputMapping/partials/sectionInfoTypes/UnorderedList/UnorderedList.vue';
import { formatChoice } from '@/utils/formatters/simpleChoice';
import { SIMPLE_CHOICE } from '@/features/ChoicesLists/Simple/types';
import { getLocaleDateString } from '@/utils/dates/dates';
import HsnTsnInfo from '@/components/modals/InputMapping/partials/sectionInfoTypes/HsnTsnInfo/HsnTsnInfo.vue';
import { formatNumber } from '@/utils/formatters/number';
import { usePkwv2InputStore } from '@/features/Sparten/pkwv2/useInputStore';
import { computed } from 'vue';
import { INPUT_MAPPING_SOURCE } from '@/features/InputMapping/types';

export const carGroupMapping: InputMappingGroup = {
  icon: 'car',
  label: 'Fahrzeug',
  infos: [
    {
      component: HsnTsnInfo,
      props: {
        hsnPath: 'fahrzeug.hsn',
        tsnPath: 'fahrzeug.tsn',
      },
      requiredPaths: ['fahrzeug.hsn', 'fahrzeug.tsn'],
    },
    {
      component: UnorderedList,
      props: {
        fields: [
          {
            path: 'fahrzeug.fahrleistung',
            suffix: 'km',
            formatter: formatNumber,
            allowedSources: [
              INPUT_MAPPING_SOURCE.GDV,
              INPUT_MAPPING_SOURCE.INVENTORY_CONTRACT,
            ],
          },
          {
            path: 'fahrzeug.kilometerstand',
            suffix: 'km',
            formatter: formatNumber,
            allowedSources: [
              INPUT_MAPPING_SOURCE.GDV,
              INPUT_MAPPING_SOURCE.INVENTORY_CONTRACT,
            ],
          },
          {
            path: 'fahrzeug.neuwert',
            suffix: '€',
            formatter: formatNumber,
          },
          {
            path: 'fahrzeug.finanzierungsart',
            formatter: formatChoice(SIMPLE_CHOICE.FINANZIERUNGSART),
          },
          {
            path: 'fahrzeug.erstzulassung',
            formatter: getLocaleDateString,
          },
          {
            path: 'fahrzeug.erstmaligeZulassungAufVN',
            formatter: getLocaleDateString,
            isHidden: computed(
              () => usePkwv2InputStore().fahrzeug.erstbesitzer,
            ),
          },
          {
            path: 'fahrzeug.stellplatz',
            formatter: formatChoice(SIMPLE_CHOICE.PARKING_LOT),
          },
          {
            path: 'fahrzeug.nutzungsart',
            formatter: formatChoice(SIMPLE_CHOICE.NUTZUNGSART),
          },
          {
            label: 'Fahrzeugidentifikationsnummer',
            path: 'fahrzeugdaten.fahrzeugIDNummer',
            isContractField: true,
          },
          {
            label: 'Kennzeichen',
            path: 'fahrzeugdaten.kennzeichen',
            isContractField: true,
          },
        ],
      },

      requiredPaths: [
        'fahrzeug.fahrleistung',
        'fahrzeug.kilometerstand',
        'fahrzeug.neuwert',
        'fahrzeug.finanzierungsart',
        'fahrzeug.erstzulassung',
        'fahrzeug.erstmaligeZulassungAufVN',
        'fahrzeug.stellplatz',
        'fahrzeug.nutzungsart',
        'fahrzeugdaten.fahrzeugIDNummer',
        'fahrzeugdaten.kennzeichen',
      ],
      requiredOr: true,
    },
  ],
};
